import React from 'react'

const MainDetailNav = ({ onBackClick }) => (
  <div className="row MainDetailNav">
    <div className="col">
      <button onClick={onBackClick}>〈 Back</button>
    </div>
  </div>
)

export default MainDetailNav



// WEBPACK FOOTER //
// ./src/components/MainDetail/MainDetailNav/MainDetailNav.js